
      var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAddressFinderSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1440,
  height: 240,
  viewBox: "0 0 1440 240",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M797.199 143.981c5.194 2.803 16.868 5.887 22.013-4.205 5.144-10.091-2.804-17.725-7.421-20.281-.742-4.452-4.699-13.307-14.592-13.109-9.894.198-13.027 8.822-13.357 13.109-3.71 0-14.098 8.657-7.667 20.281 5.145 9.3 16.159 6.679 21.024 4.205Zm0 0v-5.07m0-16.448v11.377m0 0 7.172-3.71m-7.172 3.71v5.071m0 0-7.668-5.071m7.668 5.071v22.635",
  stroke: "#000",
  strokeWidth: 2.536,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M596.32 160.871v-25.419a2.04 2.04 0 0 0-.652-1.498l-19.935-18.404a1.971 1.971 0 0 0-2.682 0l-19.932 18.404a2.04 2.04 0 0 0-.652 1.498v25.419",
  stroke: "#000",
  strokeWidth: 2.536,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M580.371 160.87v-13.954a1.993 1.993 0 0 0-1.993-1.993h-7.974a1.993 1.993 0 0 0-1.993 1.993v13.954",
  stroke: "#000",
  strokeWidth: 2.536,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#addressFinderSuccess_472d5d2e66bc4396__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#addressFinderSuccess_472d5d2e66bc4396__b)",
  stroke: "#000",
  strokeWidth: 2.536,
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M869.99 160.645V147.32a2.187 2.187 0 0 0-2.187-2.188h-5.172a2.188 2.188 0 0 0-2.188 2.188v13.325M847.839 161.488v-24.516M882.5 161.488v-24.516M850.106 114.374h30.127c1.206 0 2.304.697 2.815 1.791l5.174 11.07a.919.919 0 0 1-.833 1.308H842.95a.919.919 0 0 1-.833-1.308l5.173-11.07a3.106 3.106 0 0 1 2.816-1.791ZM874.119 129.812v.596a6.564 6.564 0 0 0 13.127 0v-.596M858.009 129.812a7.16 7.16 0 0 0 14.321 0M843.092 129.812v.596a6.564 6.564 0 0 0 13.127 0v-.596M872.827 128.22l-3.282-13.127m-12.033 13.127 3.282-13.127"
})))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M637.637 146.26c3.345 1.806 10.864 3.792 14.177-2.708 3.314-6.499-1.805-11.416-4.779-13.062-.478-2.868-3.026-8.571-9.398-8.443-6.372.127-8.39 5.681-8.603 8.443-2.389 0-9.08 5.575-4.938 13.062 3.313 5.99 10.408 4.301 13.541 2.708Zm0 0v-3.265m0-10.594v7.328m0 0 4.619-2.39m-4.619 2.39v3.266m0 0-4.939-3.266m4.939 3.266v18.087",
  stroke: "#000",
  strokeWidth: 2.113,
  strokeLinecap: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M1503 160v2H532v-2h971Z",
  fill: "#000"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#addressFinderSuccess_472d5d2e66bc4396__c)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M684.849 152.116h84.422c16.118 0 48.993 17.15 68.942 17.15H1458.5",
  stroke: "url(#addressFinderSuccess_472d5d2e66bc4396__d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M684.5 142.302h75.529c16.139 0 37.971 40.664 78.03 40.664H1455",
  stroke: "url(#addressFinderSuccess_472d5d2e66bc4396__e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M684.5 161h84.529c16.139 0 49.056 15.096 69.03 15.096H1462",
  stroke: "url(#addressFinderSuccess_472d5d2e66bc4396__f)"
}))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M732.142 161.743v-7.806a1.887 1.887 0 1 1 3.775.001v7.805h-3.775Z",
  fill: "url(#addressFinderSuccess_472d5d2e66bc4396__g)",
  stroke: "url(#addressFinderSuccess_472d5d2e66bc4396__h)",
  strokeWidth: 0.394
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M696.492 107.911a2.166 2.166 0 0 1 0-4.332h1.969a2.166 2.166 0 0 1 0 4.332h-1.969Z",
  fill: "url(#addressFinderSuccess_472d5d2e66bc4396__i)",
  stroke: "url(#addressFinderSuccess_472d5d2e66bc4396__j)",
  strokeWidth: 0.394
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M708.305 107.911a2.166 2.166 0 0 1 0-4.332h1.969a2.166 2.166 0 0 1 0 4.332h-1.969Z",
  fill: "url(#addressFinderSuccess_472d5d2e66bc4396__k)",
  stroke: "url(#addressFinderSuccess_472d5d2e66bc4396__l)",
  strokeWidth: 0.394
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M696.492 117.755a2.166 2.166 0 0 1 0-4.332h1.969a2.166 2.166 0 0 1 0 4.332h-1.969Z",
  fill: "url(#addressFinderSuccess_472d5d2e66bc4396__m)",
  stroke: "url(#addressFinderSuccess_472d5d2e66bc4396__n)",
  strokeWidth: 0.394
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M708.305 117.755a2.166 2.166 0 0 1 0-4.332h1.969a2.166 2.166 0 0 1 0 4.332h-1.969Z",
  fill: "url(#addressFinderSuccess_472d5d2e66bc4396__o)",
  stroke: "url(#addressFinderSuccess_472d5d2e66bc4396__p)",
  strokeWidth: 0.394
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M749.246 161.546V109.12a5.906 5.906 0 0 0-5.906-5.906h-21.992v58.332",
  stroke: "url(#addressFinderSuccess_472d5d2e66bc4396__q)",
  strokeWidth: 2.536,
  strokeLinecap: "round"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M721.348 160.701v-65.79a5.906 5.906 0 0 0-3.075-5.183l-25.384-13.866c-3.936-2.15-8.738.699-8.738 5.184V160.7",
  stroke: "url(#addressFinderSuccess_472d5d2e66bc4396__r)",
  strokeWidth: 2.536,
  strokeLinecap: "round"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M750 160v2H-36v-2h786Z",
  fill: "#000"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M737.134 48.067S730.425 42 720.317 42 703.5 48.067 703.5 48.067",
  stroke: "url(#addressFinderSuccess_472d5d2e66bc4396__s)",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M729.49 55.65s-3.66-3.033-9.173-3.033-9.173 3.033-9.173 3.033",
  stroke: "url(#addressFinderSuccess_472d5d2e66bc4396__t)",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 720.244,
  cy: 63.209,
  r: 2.5,
  fill: "url(#addressFinderSuccess_472d5d2e66bc4396__u)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "addressFinderSuccess_472d5d2e66bc4396__d",
  x1: 684.849,
  y1: 169.266,
  x2: 950.037,
  y2: 124.747,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#810EA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC32CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "addressFinderSuccess_472d5d2e66bc4396__e",
  x1: 684.5,
  y1: 156.601,
  x2: 952.586,
  y2: 120.276,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#810EA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC32CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "addressFinderSuccess_472d5d2e66bc4396__f",
  x1: 684.5,
  y1: 176.096,
  x2: 952.586,
  y2: 212.421,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#810EA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC32CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "addressFinderSuccess_472d5d2e66bc4396__g",
  x1: 735.72,
  y1: 161.546,
  x2: 732.363,
  y2: 161.555,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#810EA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC32CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "addressFinderSuccess_472d5d2e66bc4396__h",
  x1: 735.72,
  y1: 161.546,
  x2: 732.363,
  y2: 161.555,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#810EA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC32CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "addressFinderSuccess_472d5d2e66bc4396__i",
  x1: 700.43,
  y1: 107.713,
  x2: 694.567,
  y2: 107.777,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#810EA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC32CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "addressFinderSuccess_472d5d2e66bc4396__j",
  x1: 700.43,
  y1: 107.713,
  x2: 694.567,
  y2: 107.777,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#810EA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC32CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "addressFinderSuccess_472d5d2e66bc4396__k",
  x1: 712.243,
  y1: 107.713,
  x2: 706.38,
  y2: 107.777,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#810EA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC32CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "addressFinderSuccess_472d5d2e66bc4396__l",
  x1: 712.243,
  y1: 107.713,
  x2: 706.38,
  y2: 107.777,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#810EA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC32CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "addressFinderSuccess_472d5d2e66bc4396__m",
  x1: 700.43,
  y1: 117.558,
  x2: 694.567,
  y2: 117.621,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#810EA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC32CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "addressFinderSuccess_472d5d2e66bc4396__n",
  x1: 700.43,
  y1: 117.558,
  x2: 694.567,
  y2: 117.621,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#810EA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC32CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "addressFinderSuccess_472d5d2e66bc4396__o",
  x1: 712.243,
  y1: 117.558,
  x2: 706.38,
  y2: 117.621,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#810EA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC32CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "addressFinderSuccess_472d5d2e66bc4396__p",
  x1: 712.243,
  y1: 117.558,
  x2: 706.38,
  y2: 117.621,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#810EA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC32CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "addressFinderSuccess_472d5d2e66bc4396__q",
  x1: 721.348,
  y1: 103.214,
  x2: 749.044,
  y2: 103.118,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#810EA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC32CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "addressFinderSuccess_472d5d2e66bc4396__r",
  x1: 684.151,
  y1: 71.089,
  x2: 721.078,
  y2: 70.978,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#810EA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC32CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "addressFinderSuccess_472d5d2e66bc4396__s",
  x1: 703.5,
  y1: 42,
  x2: 736.836,
  y2: 40.661,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#810EA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC32CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "addressFinderSuccess_472d5d2e66bc4396__t",
  x1: 711.144,
  y1: 52.617,
  x2: 729.322,
  y2: 51.82,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#810EA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC32CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "addressFinderSuccess_472d5d2e66bc4396__u",
  x1: 717.744,
  y1: 60.709,
  x2: 722.708,
  y2: 60.673,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#810EA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BC32CE"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "addressFinderSuccess_472d5d2e66bc4396__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(833.714 101.023)",
  d: "M0 0h63.787v63.787H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "addressFinderSuccess_472d5d2e66bc4396__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(839.232 113.359)",
  d: "M0 0h51.569v51.569H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "addressFinderSuccess_472d5d2e66bc4396__c"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(749 140)",
  d: "M0 0h692v45H0z"
})))));

      const __svgRaw = "<svg width=\"1440\" height=\"240\" viewBox=\"0 0 1440 240\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M797.199 143.981C802.393 146.784 814.067 149.868 819.212 139.776C824.356 129.685 816.408 122.051 811.791 119.495C811.049 115.043 807.092 106.188 797.199 106.386C787.305 106.584 784.172 115.208 783.842 119.495C780.132 119.495 769.744 128.152 776.175 139.776C781.32 149.076 792.334 146.455 797.199 143.981ZM797.199 143.981V138.911M797.199 122.463V133.84M797.199 133.84L804.371 130.13M797.199 133.84V138.911M797.199 138.911L789.531 133.84M797.199 138.911V161.546\" stroke=\"black\" stroke-width=\"2.53617\" stroke-linecap=\"round\"/>\r\n<path d=\"M596.32 160.871V135.452C596.32 134.881 596.083 134.338 595.668 133.954L575.733 115.55C574.972 114.848 573.811 114.848 573.051 115.55L553.119 133.954C552.704 134.338 552.467 134.881 552.467 135.452V160.871\" stroke=\"black\" stroke-width=\"2.53617\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M580.371 160.87V146.916C580.371 145.815 579.479 144.923 578.378 144.923H570.404C569.303 144.923 568.411 145.815 568.411 146.916V160.87\" stroke=\"black\" stroke-width=\"2.53617\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<g clip-path=\"url(#clip0_3950_34942)\">\r\n<g clip-path=\"url(#clip1_3950_34942)\">\r\n<path d=\"M869.99 160.645V147.32C869.99 146.111 869.011 145.132 867.803 145.132H862.631C861.423 145.132 860.443 146.111 860.443 147.32V160.645\" stroke=\"black\" stroke-width=\"2.53617\" stroke-linecap=\"round\"/>\r\n<path d=\"M847.839 161.488V136.972\" stroke=\"black\" stroke-width=\"2.53617\" stroke-linecap=\"round\"/>\r\n<path d=\"M882.5 161.488V136.972\" stroke=\"black\" stroke-width=\"2.53617\" stroke-linecap=\"round\"/>\r\n<path d=\"M850.106 114.374H880.233C881.439 114.374 882.537 115.071 883.048 116.165L888.222 127.235C888.507 127.845 888.062 128.543 887.389 128.543H842.95C842.277 128.543 841.832 127.845 842.117 127.235L847.29 116.165C847.801 115.071 848.899 114.374 850.106 114.374Z\" stroke=\"black\" stroke-width=\"2.53617\" stroke-linecap=\"round\"/>\r\n<path d=\"M874.119 129.812V130.408C874.119 134.033 877.058 136.972 880.683 136.972C884.308 136.972 887.246 134.033 887.246 130.408V129.812\" stroke=\"black\" stroke-width=\"2.53617\" stroke-linecap=\"round\"/>\r\n<path d=\"M858.009 129.812C858.009 133.766 861.215 136.972 865.169 136.972C869.124 136.972 872.33 133.766 872.33 129.812\" stroke=\"black\" stroke-width=\"2.53617\" stroke-linecap=\"round\"/>\r\n<path d=\"M843.092 129.812V130.408C843.092 134.033 846.031 136.972 849.656 136.972C853.281 136.972 856.219 134.033 856.219 130.408V129.812\" stroke=\"black\" stroke-width=\"2.53617\" stroke-linecap=\"round\"/>\r\n<path d=\"M872.827 128.22L869.545 115.093M857.512 128.22L860.794 115.093\" stroke=\"black\" stroke-width=\"2.53617\" stroke-linecap=\"round\"/>\r\n</g>\r\n</g>\r\n<path d=\"M637.637 146.26C640.982 148.066 648.501 150.052 651.814 143.552C655.128 137.053 650.009 132.136 647.035 130.49C646.557 127.622 644.009 121.919 637.637 122.047C631.265 122.174 629.247 127.728 629.034 130.49C626.645 130.49 619.954 136.065 624.096 143.552C627.409 149.542 634.504 147.853 637.637 146.26ZM637.637 146.26V142.995M637.637 132.401V139.729M637.637 139.729L642.256 137.339M637.637 139.729V142.995M637.637 142.995L632.698 139.729M637.637 142.995L637.637 161.082\" stroke=\"black\" stroke-width=\"2.11347\" stroke-linecap=\"round\"/>\r\n<path d=\"M1503 160V162H532V160H1503Z\" fill=\"black\"/>\r\n<g clip-path=\"url(#clip2_3950_34942)\">\r\n<path d=\"M684.849 152.116C707.617 152.116 756.376 152.116 769.271 152.116C785.389 152.116 818.264 169.266 838.213 169.266C854.172 169.266 1424.72 169.266 1458.5 169.266\" stroke=\"url(#paint0_linear_3950_34942)\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M684.5 142.302C707.297 142.302 747.118 142.302 760.029 142.302C776.168 142.302 798 182.966 838.059 182.966C854.038 182.966 1421.18 182.966 1455 182.966\" stroke=\"url(#paint1_linear_3950_34942)\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M684.5 161C707.297 161 756.118 161 769.029 161C785.168 161 818.085 176.096 838.059 176.096C854.038 176.096 1428.18 176.096 1462 176.096\" stroke=\"url(#paint2_linear_3950_34942)\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n</g>\r\n<path d=\"M732.142 161.743L732.142 153.937C732.142 152.895 732.987 152.05 734.029 152.05C735.072 152.05 735.917 152.895 735.917 153.938L735.917 161.743L732.142 161.743Z\" fill=\"url(#paint3_linear_3950_34942)\" stroke=\"url(#paint4_linear_3950_34942)\" stroke-width=\"0.393755\"/>\r\n<path d=\"M696.492 107.911C695.296 107.911 694.326 106.941 694.326 105.745C694.326 104.549 695.296 103.579 696.492 103.579L698.461 103.579C699.657 103.579 700.627 104.549 700.627 105.745C700.627 106.941 699.657 107.911 698.461 107.911L696.492 107.911Z\" fill=\"url(#paint5_linear_3950_34942)\" stroke=\"url(#paint6_linear_3950_34942)\" stroke-width=\"0.393755\"/>\r\n<path d=\"M708.305 107.911C707.109 107.911 706.139 106.941 706.139 105.745C706.139 104.549 707.109 103.579 708.305 103.579L710.274 103.579C711.47 103.579 712.44 104.549 712.44 105.745C712.44 106.941 711.47 107.911 710.274 107.911L708.305 107.911Z\" fill=\"url(#paint7_linear_3950_34942)\" stroke=\"url(#paint8_linear_3950_34942)\" stroke-width=\"0.393755\"/>\r\n<path d=\"M696.492 117.755C695.296 117.755 694.326 116.785 694.326 115.589C694.326 114.393 695.296 113.423 696.492 113.423L698.461 113.423C699.657 113.423 700.627 114.393 700.627 115.589C700.627 116.785 699.657 117.755 698.461 117.755L696.492 117.755Z\" fill=\"url(#paint9_linear_3950_34942)\" stroke=\"url(#paint10_linear_3950_34942)\" stroke-width=\"0.393755\"/>\r\n<path d=\"M708.305 117.755C707.109 117.755 706.139 116.785 706.139 115.589C706.139 114.393 707.109 113.423 708.305 113.423L710.274 113.423C711.47 113.423 712.44 114.393 712.44 115.589C712.44 116.785 711.47 117.755 710.274 117.755L708.305 117.755Z\" fill=\"url(#paint11_linear_3950_34942)\" stroke=\"url(#paint12_linear_3950_34942)\" stroke-width=\"0.393755\"/>\r\n<path d=\"M749.246 161.546V109.12C749.246 105.858 746.602 103.214 743.34 103.214H721.348V161.546\" stroke=\"url(#paint13_linear_3950_34942)\" stroke-width=\"2.53617\" stroke-linecap=\"round\"/>\r\n<path d=\"M721.348 160.701V94.9119C721.348 92.7518 720.169 90.764 718.273 89.7285L692.889 75.8623C688.953 73.7123 684.151 76.5609 684.151 81.0457V160.701\" stroke=\"url(#paint14_linear_3950_34942)\" stroke-width=\"2.53617\" stroke-linecap=\"round\"/>\r\n<path d=\"M750 160V162H-36V160H750Z\" fill=\"black\"/>\r\n<path d=\"M737.134 48.0667C737.134 48.0667 730.425 42 720.317 42C710.209 42 703.5 48.0667 703.5 48.0667\" stroke=\"url(#paint15_linear_3950_34942)\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M729.49 55.65C729.49 55.65 725.83 52.6167 720.317 52.6167C714.804 52.6167 711.144 55.65 711.144 55.65\" stroke=\"url(#paint16_linear_3950_34942)\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<circle cx=\"720.244\" cy=\"63.2095\" r=\"2.5\" fill=\"url(#paint17_linear_3950_34942)\"/>\r\n<defs>\r\n<linearGradient id=\"paint0_linear_3950_34942\" x1=\"684.849\" y1=\"169.266\" x2=\"950.037\" y2=\"124.747\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"#810EA9\"/>\r\n<stop offset=\"1\" stop-color=\"#BC32CE\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint1_linear_3950_34942\" x1=\"684.5\" y1=\"156.601\" x2=\"952.586\" y2=\"120.276\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"#810EA9\"/>\r\n<stop offset=\"1\" stop-color=\"#BC32CE\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint2_linear_3950_34942\" x1=\"684.5\" y1=\"176.096\" x2=\"952.586\" y2=\"212.421\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"#810EA9\"/>\r\n<stop offset=\"1\" stop-color=\"#BC32CE\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint3_linear_3950_34942\" x1=\"735.72\" y1=\"161.546\" x2=\"732.363\" y2=\"161.555\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"#810EA9\"/>\r\n<stop offset=\"1\" stop-color=\"#BC32CE\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint4_linear_3950_34942\" x1=\"735.72\" y1=\"161.546\" x2=\"732.363\" y2=\"161.555\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"#810EA9\"/>\r\n<stop offset=\"1\" stop-color=\"#BC32CE\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint5_linear_3950_34942\" x1=\"700.43\" y1=\"107.713\" x2=\"694.567\" y2=\"107.777\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"#810EA9\"/>\r\n<stop offset=\"1\" stop-color=\"#BC32CE\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint6_linear_3950_34942\" x1=\"700.43\" y1=\"107.713\" x2=\"694.567\" y2=\"107.777\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"#810EA9\"/>\r\n<stop offset=\"1\" stop-color=\"#BC32CE\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint7_linear_3950_34942\" x1=\"712.243\" y1=\"107.713\" x2=\"706.38\" y2=\"107.777\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"#810EA9\"/>\r\n<stop offset=\"1\" stop-color=\"#BC32CE\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint8_linear_3950_34942\" x1=\"712.243\" y1=\"107.713\" x2=\"706.38\" y2=\"107.777\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"#810EA9\"/>\r\n<stop offset=\"1\" stop-color=\"#BC32CE\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint9_linear_3950_34942\" x1=\"700.43\" y1=\"117.558\" x2=\"694.567\" y2=\"117.621\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"#810EA9\"/>\r\n<stop offset=\"1\" stop-color=\"#BC32CE\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint10_linear_3950_34942\" x1=\"700.43\" y1=\"117.558\" x2=\"694.567\" y2=\"117.621\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"#810EA9\"/>\r\n<stop offset=\"1\" stop-color=\"#BC32CE\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint11_linear_3950_34942\" x1=\"712.243\" y1=\"117.558\" x2=\"706.38\" y2=\"117.621\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"#810EA9\"/>\r\n<stop offset=\"1\" stop-color=\"#BC32CE\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint12_linear_3950_34942\" x1=\"712.243\" y1=\"117.558\" x2=\"706.38\" y2=\"117.621\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"#810EA9\"/>\r\n<stop offset=\"1\" stop-color=\"#BC32CE\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint13_linear_3950_34942\" x1=\"721.348\" y1=\"103.214\" x2=\"749.044\" y2=\"103.118\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"#810EA9\"/>\r\n<stop offset=\"1\" stop-color=\"#BC32CE\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint14_linear_3950_34942\" x1=\"684.151\" y1=\"71.0894\" x2=\"721.078\" y2=\"70.9783\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"#810EA9\"/>\r\n<stop offset=\"1\" stop-color=\"#BC32CE\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint15_linear_3950_34942\" x1=\"703.5\" y1=\"42\" x2=\"736.836\" y2=\"40.6613\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"#810EA9\"/>\r\n<stop offset=\"1\" stop-color=\"#BC32CE\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint16_linear_3950_34942\" x1=\"711.144\" y1=\"52.6167\" x2=\"729.322\" y2=\"51.8204\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"#810EA9\"/>\r\n<stop offset=\"1\" stop-color=\"#BC32CE\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint17_linear_3950_34942\" x1=\"717.744\" y1=\"60.7095\" x2=\"722.708\" y2=\"60.6735\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"#810EA9\"/>\r\n<stop offset=\"1\" stop-color=\"#BC32CE\"/>\r\n</linearGradient>\r\n<clipPath id=\"clip0_3950_34942\">\r\n<rect width=\"63.7866\" height=\"63.7866\" fill=\"white\" transform=\"translate(833.714 101.023)\"/>\r\n</clipPath>\r\n<clipPath id=\"clip1_3950_34942\">\r\n<rect width=\"51.5687\" height=\"51.5687\" fill=\"white\" transform=\"translate(839.232 113.359)\"/>\r\n</clipPath>\r\n<clipPath id=\"clip2_3950_34942\">\r\n<rect width=\"692\" height=\"45\" fill=\"white\" transform=\"translate(749 140)\"/>\r\n</clipPath>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/addressFinderSuccess.472d5d2e66bc439697fbbab4e6b6b125.svg"),
        {
          React: SvgAddressFinderSuccess,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      